import React from 'react'
import { IntroductionComponent } from './components/IntroductionComponent';
import { AboutComponent } from './components/AboutComponent';
import ServicesComponent from './components/ServicesComponent';
import ContactusComponent from './components/ContactusComponent';
import DomainExpertiseComponent from './components/DomainExpertiseComponent';

const Home = () => {
  return (
    <main className='main'>
        <IntroductionComponent />
        <AboutComponent />
        <ServicesComponent />
        <DomainExpertiseComponent />
        <ContactusComponent />
    </main>
  )
}

export default Home;
